var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ymap-marker',{attrs:{"coords":_vm.coords,"marker-id":("filial-" + (_vm.filial.id)),"hint-content":_vm.filial.name,"balloon-template":_vm.balloonTemplate,"icon":_vm.icon}})}
var staticRenderFns = []

export { render, staticRenderFns }